module.exports = __webpack_public_path__ + "static/media/logo.1276c7b8.png";